import clsx from "clsx";
import type { GroupIconProps, GroupIconSize } from "./types";

const SIZE_CLASSES: Record<GroupIconSize, string> = {
  xs: "w-6 h-6",
  sm: "w-8 h-8",
  md: "w-12 h-12",
  lg: "w-16 h-16",
};

export const GroupIcon = ({
  dataUrl,
  disableHover,
  size = "md",
}: GroupIconProps) => {
  const sizeClasses = SIZE_CLASSES[size];

  if (dataUrl) {
    return (
      <img
        src={dataUrl}
        alt=""
        className={clsx(
          sizeClasses,
          "rounded border border-gray-200 object-cover shrink-0",
          !disableHover &&
            "transition-transform duration-200 hover:scale-150 hover:shadow-md relative hover:z-10",
        )}
        draggable={false}
      />
    );
  }

  return (
    <div
      className={clsx(
        sizeClasses,
        "rounded border border-gray-200 shrink-0 animate-pulse bg-gray-300",
      )}
    />
  );
};
